import { ConfigStateService, RoutesService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsDto } from 'src/core/models/settings/settings.dto';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IntegrationSettingsDto } from 'src/core/models/settings/integration-settings.dto';
import { SettingsTestResultDto } from 'src/core/models/settings/settings-test-result.dto';
import { resolveUrl, API_PREFIX } from 'src/core/constants/api.constants';

const SETTINGS = `${API_PREFIX}/custom-settings`;

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  constructor(
    private config: ConfigStateService,
    private routesService: RoutesService,
    private http: HttpClient
  ) {}

  checkRoutesForSettings(): void {
    const flatItems = this.routesService.flat;

    for (let i = 0; i < flatItems.length; i++) {
      const item = flatItems[i] as any;

      if (Array.isArray(item.forSettings)) {
        const isEnabled = this.isEnabled(item.forSettings);

        if (!isEnabled) {
          this.routesService.remove([item.name]);
        }
      }
    }
  }

  isEnabled(settings: string | string[]): boolean {
    let result = true;

    if (!Array.isArray(settings)) {
      settings = [settings];
    }

    if (!Array.isArray(settings) || settings.length <= 0) {
      result = false;
    } else {
      for (let i = 0; i < settings.length; i++) {
        let settingEnabled = false;

        try {
          settingEnabled = JSON.parse(this.config.getSetting(settings[i]).toLowerCase());
        } catch (e) {
          settingEnabled = false;
        }

        result = result && settingEnabled;
      }
    }

    return result;
  }

  saveSetting(settings: SettingsDto[]): Observable<any> {
    let tenantId = this.config.getDeep(['currentUser', 'tenantId']);
    let isHost = tenantId == null;
    const address = isHost
      ? resolveUrl(`${SETTINGS}/set-host-settings`)
      : resolveUrl(`${SETTINGS}/set`);

    return this.http.post(address, settings).pipe(
      map(response => {
        this.config.refreshAppState().subscribe();
        return response;
      }),
      catchError(error => {
        return throwError(() => error);
      })
    ) as Observable<any>;
  }

  saveIntegration(settings: IntegrationSettingsDto): Observable<any> {
    return this.http.post(resolveUrl(`${SETTINGS}/set-integration`), settings).pipe(
      map(response => {
        this.config.refreshAppState().subscribe();
        return response;
      }),
      catchError(error => {
        return throwError(() => error);
      })
    ) as Observable<any>;
  }

  testSettingsConnection(isVirtualAgent: boolean = false): Observable<SettingsTestResultDto> {
    return this.http.get<SettingsTestResultDto>(resolveUrl(`${SETTINGS}/test-connection?isVirtualAgent=${isVirtualAgent}`)).pipe(
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
}
